import actions from './account.actions'
import getters from './account.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
